module.exports = __webpack_public_path__ + "img/25.e191d000.png";